var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
// main handler for this mixin
import { Const } from './provider/candle-history/lib/const.cls';
import { mapActions } from 'vuex';
import { giniView } from './lib/giniView.cls';
import * as giniViewStoreExtensions from './provider/candle-history';
// add plugin store extensions to store properties
var state = __assign({}, giniViewStoreExtensions.stateExt);
var actions = __assign({}, giniViewStoreExtensions.actionsExt);
var mutations = __assign({}, giniViewStoreExtensions.mutationsExt);
var getters = __assign({}, giniViewStoreExtensions.gettersExt);
// new store module definition
var giniViewStore = {
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
};
// main mixin to load the new store module
export var giniViewMixins = {
    created: function () {
        // dynamically extend store with scalpertStore plugin
        var _store = this.$store;
        if (!(_store && _store.state && _store.state[giniView.STORE_MODULE_NAME])) {
            try {
                this.$store.registerModule(giniView.STORE_MODULE_NAME, giniViewStore);
            }
            catch (error) { }
        }
    },
    methods: __assign({}, mapActions({
        _runRegisterStep1: Const.RUN_REGISTER_STEP1,
        _runRegisterStep2: Const.RUN_REGISTER_STEP2,
        _runRegisterStep3: Const.RUN_REGISTER_STEP3,
        _runRegisterStep4: Const.RUN_REGISTER_STEP4,
        _runCallRequest: Const.RUN_CALL_REQUEST,
        _runContactUs: Const.RUN_CONTACT_US,
        _runGetRegisterData: Const.RUN_GET_REGISTER_DATA,
        _runDiabetesForm: Const.RUN_DIABETES_FORM,
        _runCheckEmail: Const.RUN_CHECK_EMAIL,
        _runPayURequestInitiate: Const.RUN_PAYU_REQUEST_INITIATE,
        _runGetTimeSlots: Const.RUN_GET_TIME_SLOTS,
        _runFindProgramForm: Const.RUN_FIND_PROGRAM_FORM,
    }), { computedCommonFunc: function (getFuncName) {
            try {
                return this.$store.getters[getFuncName];
            }
            catch (ex) {
                return [];
            }
        } }),
    computed: {
        registerData: function () { return this.computedCommonFunc(Const.GET_REGISTER_DATA); },
        PaymentData: function () { return this.computedCommonFunc(Const.GET_PAYU_REQUEST_INITIATE); },
        timeSlots: function () { return this.computedCommonFunc(Const.GET_TIME_SLOTS); },
    },
};
export default giniViewMixins;
// export all mixins for data-warehouse plugin



//////////////////
// WEBPACK FOOTER
// ./src/plugins/giniView/index.ts
// module id = null
// module chunks = 